import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React from 'react';
import * as v from '../../../helpers/validation';
import { Paper } from '@material-ui/core';
// SERVICES
import { createAdminUser } from '../../../services';
import { DynamicForm } from '../../DynamicForm';

const styles = theme => ({
  paper: { padding: '24px', boxSizing: 'border-box', height: '100%' },
});

export const AdminUsersCreate = withStyles(styles)(({ classes }) => {
  const adminUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'email',
              label: 'Email',
              validate: [v.required()],
            },
            {
              inputType: 'password',
              field: 'password',
              label: 'Password',
              validate: [v.required()],
              hideOnEdit: true,
            },
          ],
        },
      ],
    },
  ];

  return (
    <Paper className={classnames(classes.paper, 'border-left-green')} elevation={1}>
      <DynamicForm
        inputs={adminUserInputs}
        mode={'CREATE'}
        onSave={createAdminUser}
        redirectOnSuccess={'/users/admin'}
      />
    </Paper>
  );
});
